const ACTIONS = [
  { key: "void_item", label: "Void Item", danger: true },
  { key: "recall", label: "Recall Hold Bill" },
  { key: "quantity", label: "Quantity" },
  { key: "issue_loyalty", label: "Issue Loyalty" },
  { key: "opening_amount", label: "Opening Amount" },
  { key: "redeem_loyalty", label: "Redeemed Loyalty" },
  { key: "pay_credit_memo", label: "Pay Credit Memo Old" },
  { key: "logoff", label: "Log Off" },
  { key: "tender_declaration", label: "Tender Declaration" },
  { key: "void_payment", label: "Void Payment", danger: true },
  { key: "clear_bill", label: "Clear Bill", danger: true },
  { key: "emp_disc", label: "V2 Emp Disc" },
];

export function ActionPanel({ onAction }) {
  return (
    <div className="action-panel" data-testid="action-panel">
      {ACTIONS.map((a) => (
        <button
          key={a.key}
          className={`win-btn ${a.danger ? "danger" : ""}`}
          onClick={() => onAction(a.key)}
          data-testid={`action-${a.key}`}
        >
          {a.label}
        </button>
      ))}
    </div>
  );
}
